module.exports = __webpack_public_path__ + "static/img/yunxing.537fb619.png";